import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
import ActionButton from './ActionButton';

export const FullScreenMapDialog = ({ 
    children, 
    visible, 
    onHide, 
    header 
}) => {
    const dialogStyle = {
        width: '98vw',
        height: '98vh',
        maxWidth: 'none',
        maxHeight: 'none',
        margin: '1vh 1vw',
    };

    const contentStyle = {
        height: 'calc(98vh - 80px)', // Odejmujemy wysokość nagłówka
        overflow: 'hidden',
        padding: '0'
    };

    const headerTemplate = (
        <div className="fullscreen-map-header">
            <h3 style={{ margin: 0, fontSize: '1.5rem', fontWeight: '600' }}>{header}</h3>
            <ActionButton 
                iconName="mdi-close"                 
                handleClick={onHide}                
                style={{ marginLeft: 'auto' }}
            />
        </div>
    );

    return (
        <Dialog
            visible={visible}
            style={dialogStyle}
            className="fullscreen-map-dialog"
            modal={true}
            closable={false}
            onHide={onHide}
            header={headerTemplate}
            contentStyle={contentStyle}
            draggable={false}
            resizable={false}
            blockScroll={true}
        >
            {children}
        </Dialog>
    );
};

FullScreenMapDialog.propTypes = {
    children: PropTypes.node.isRequired,
    visible: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
};

export default withTranslation()(FullScreenMapDialog);
